// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".swiper-pagination .my-bullet{margin:4px;background-color:hsla(0,0%,100%,.3);width:8px;height:8px;display:inline-block;border-radius:100%}.swiper-pagination .my-bullet-active{background-color:#fff}.banner .img{width:100%;max-height:800px}", ""]);
// Exports
module.exports = exports;
